import { Component } from '@angular/core';
import { ListComponent } from 'src/app/common/component/list.component';

import { DriversListFiltersComponent as FiltersComponent } from '../drivers-list/drivers-list-filters/drivers-list-filters.component';

@Component({
	selector: 'app-drivers-list',
	templateUrl: './drivers-list.component.html',
	styleUrls: ['./drivers-list.component.css'],
})
export class DriversListComponent extends ListComponent {
	protected itemsBeforeDataLoad = 4;
	protected apiUrl = 'drivers';
	tableRows = [
		{ id: 'first_name', name: 'Imię' },
		{ id: 'last_name', name: 'Nazwisko' },
		{ id: 'status', name: 'Status' },
		{ id: 'driverKinds', name: 'Rodzaj' },
		{ id: 'email_private', name: 'E-mail prywatny' },
		{ id: 'email_business', name: 'E-mail służbowy' },
		{ id: 'phone_private', name: 'Telefon prywatny' },
		{ id: 'phone_business', name: 'Telefon służbowy' },
		{ id: 'birthdate', name: 'Data urodzenia' },
		{ id: 'chronically_ill_name', name: 'Choroby przewlekłe' },
		{ id: 'vaccinations_name', name: 'Szczepienia' },
		{ id: 'trailer_name', name: 'Przyczepka' },
		{ id: 'comments', name: 'Uwagi' },
		{ id: 'rate', name: 'Ocena' },
		{ id: 'nearest_city', name: 'Najbliższe duże miasto' },
		{ id: 'whenContact', name: 'Data kontaktu' },
	];
	filters;
	parameters = {
		yesno: [
			{ id: 0, name: 'Brak danych' },
			{ id: 1, name: 'Tak' },
			{ id: 2, name: 'Nie' },
		],
		statuses: [
			// { id: 'REGULAR', name: 'Etat' },
			// { id: 'MAYBE', name: 'Przyszłość' },
			// { id: 'FIRED', name: 'Zwolniony' },
			// { id: 'JUMPER', name: 'Skoczek' },
			// { id: 'VIRTUAL', name: 'Wirtualny' },
			// { id: 'BLACK_LIST', name: 'Czarna lista' },
		],
		driverKinds: [],
		cities: [],
	};

	protected loadBefore() {
		this.api.get('/nearestBigCity/', (result, error) => {
			this.parameters.cities = result.data;
			this.loadData('nearestBigCity');
		});
		this.api.get('/driverKinds/', (result, error) => {
			this.parameters.driverKinds = result.data;
			this.loadData('driverKinds');
		});
		this.api.get('/driverStatus/', (result, error) => {
			this.parameters.statuses = result.data;
			this.loadData('driverStatus');
		});
	}

	protected convertData(data) {
		data.forEach((obj) => {
			const status = this.parameters.statuses.find((objfind) => objfind.id == obj.status);
			obj.status = status ? status.name : '';
			const driverKinds = this.parameters.driverKinds.find((objfind) => objfind.id == obj.driverKinds);
			obj.driverKinds = driverKinds ? driverKinds.name : '';
			const city = this.parameters.cities.find((objfind) => objfind.id == obj.nearest_city);
			obj.nearest_city = city ? city.name : '';
			const chronically_ill = this.parameters.yesno.find((objfind) => objfind.id == obj.chronically_ill);
			obj.chronically_ill_name = chronically_ill ? chronically_ill.name : '';
			const vaccinations = this.parameters.yesno.find((objfind) => objfind.id == obj.vaccinations);
			obj.vaccinations_name = obj.vaccinations ? vaccinations.name : '';
			const trailer = this.parameters.yesno.find((objfind) => objfind.id == obj.trailer);
			obj.trailer_name = obj.trailer ? trailer.name : '';
		});
		return data;
	}
}
